import React from "react";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("[ErrorBoundary]", error, info);
    try {
      const { reportClientError } = require("@/lib/reportError");
      reportClientError(error?.message || String(error), (error?.stack || "") + "\n--component--\n" + (info?.componentStack || ""), "error-boundary");
    } catch (e) { /* ignore */ }
  }

  handleReload = async () => {
    try {
      if (navigator.serviceWorker?.getRegistrations) {
        const regs = await navigator.serviceWorker.getRegistrations();
        await Promise.all(regs.map((r) => r.unregister()));
      }
      if (window.caches?.keys) {
        const keys = await caches.keys();
        await Promise.all(keys.map((k) => caches.delete(k)));
      }
    } catch (e) { /* ignore */ }
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div data-testid="error-boundary" style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#0a0a0a", color: "#fff", fontFamily: "sans-serif", padding: 24, textAlign: "center" }}>
        <div>
          <div style={{ fontSize: 40, marginBottom: 12 }}>⚽</div>
          <h1 style={{ fontSize: 20, fontWeight: 900, textTransform: "uppercase", letterSpacing: 1 }}>Algo ha fallado</h1>
          <p style={{ color: "#999", fontSize: 14, maxWidth: 360, margin: "10px auto 20px" }}>
            Ha ocurrido un error al cargar la aplicación. Pulsa el botón para recargar con la última versión.
          </p>
          <button
            data-testid="error-boundary-reload"
            onClick={this.handleReload}
            style={{ background: "#e11d2e", color: "#fff", border: "none", padding: "12px 28px", fontWeight: 900, textTransform: "uppercase", letterSpacing: 1, fontSize: 13, cursor: "pointer" }}
          >
            Recargar aplicación
          </button>
        </div>
      </div>
    );
  }
}
